import { StickyScrollFade } from '@/components/atoms/StickyScrollFade/StickyScrollFade';
import { ComplexFilterBar } from '@/components/ui/custom/ComplexFilter/ComplexFilterBar';
import { ComplexFilterCombobox } from '@/components/ui/custom/ComplexFilter/ComplexFilterCombobox';
import { useScrollFade } from '@/hooks/useScrollFade';

import { ActivityLogDateFilter } from './ActivityLogDateFilter';
import { UseActivityLogsPageReturn } from '../hooks/useActivityLogsPage';

interface ActivityLogToolbarProps {
  page: UseActivityLogsPageReturn;
}

export const ActivityLogToolbar = ({ page }: ActivityLogToolbarProps) => {
  const { scrollRef, showFade } = useScrollFade<HTMLDivElement>('top');

  return (
    <div
      ref={scrollRef}
      className="sticky top-0 z-30 flex flex-col gap-4 bg-bg-muted-light pt-4 pb-8"
    >
      <StickyScrollFade show={showFade} />
      <div className="flex items-center justify-between">
        <ActivityLogDateFilter
          selection={page.dateSelection}
          onSelectionChange={page.setDateSelection}
        />

        <ComplexFilterCombobox
          filterDefinitions={page.filterDefinitions}
          filters={page.filters}
          setFilter={page.setFilter}
          removeFilter={page.removeFilter}
          activeFilterCount={page.activeFilterCount}
          savedFilters={page.savedFilterItems}
          onApplySavedFilter={(item) => page.applyViewById(item.id)}
          onOpenActivePill={page.setOpenPillId}
          showBulkActions={false}
        />
      </div>

      <ComplexFilterBar
        filters={page.filterBadges}
        savedFiltersConfig={page.savedFiltersConfig}
        openPillId={page.openPillId}
        onOpenPillChange={page.setOpenPillId}
        onClearAll={page.handleClearFilters}
        showBulkActions={false}
      />
    </div>
  );
};
